module.exports = __webpack_public_path__ + "static/img/user.951666b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/user.png
// module id = xF60
// module chunks = 1